<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action | translate}}</strong> escenario <span *ngIf="action == 'Delete'"> {{LOCAL_DATA.nombre}}</span></h1>
<div mat-dialog-content>
      <mat-form-field *ngIf="action != 'Delete'" class="select-list">
        <input placeholder="Nombre" matInput [(ngModel)]="LOCAL_DATA.nombre" [disabled] ="action == 'View'">
      </mat-form-field>
        <!--
          <mat-form-field color="accent" appearance="fill">
            <mat-label>Fecha de creación</mat-label>
            <input matInput [matDatepicker]="LOCAL_DATA.fechaCreacion">
            <mat-datepicker-toggle matSuffix [for]="LOCAL_DATA.fechaCreacion"></mat-datepicker-toggle>
            <mat-datepicker #LOCAL_DATA.fechaCreacion></mat-datepicker>
          </mat-form-field>-->
          <!-- CONTENT CARD -->
          <div class="content-card" *ngIf="action != 'Delete'">

            <div fxLayout="row" fxLayoutAlign="end end">
              <button  mat-button (click)="print()" mat-flat-button color="primary" class="add-row" *ngIf="action == 'View'">
                <mat-icon  aria-hidden="false" aria-label="print" >print</mat-icon>
              </button>
              </div>

            <mat-tab-group animationDuration="0ms" (selectedTabChange)="reloadChart()">
              <mat-tab label="Heurísticos">

                  <!-- CONTENT -->

                  <mat-card class="example-card">
                    <mat-card-header>
                      <mat-card-title>Probabilidades</mat-card-title>

                    </mat-card-header>

                    <mat-card-content>
                      <div class="content p-5" fxLayout="column">

                        <div fxLayout="row"  fxFlex *ngIf="action != 'View' && action != 'Delete'">
                          <div fxLayout="column" fxFlex>
                              <div fxFlex>
                                <mat-form-field *ngIf="action != 'Delete'" fxFlex="80">
                                  <input placeholder="Nombre" matInput [(ngModel)]="new_line_p.nombre">
                                </mat-form-field>
                                <mat-form-field *ngIf="action != 'Delete'" fxFlex="20">
                                  <input placeholder="Valor" matInput [(ngModel)]="new_line_p.valor"
                                  onkeypress="return event.charCode >= 48 || event.charCode == 46"
                                  type="number" value="" min="0.01"  pattern="[0-9]+([\.][0-9]+)?" step="any">
                                </mat-form-field>
                              </div>
                              <div fxFlex>
                                <mat-form-field *ngIf="action != 'Delete'" fxFlex>
                                  <mat-label>Descripción</mat-label>
                                  <textarea
                                        matInput [(ngModel)]="new_line_p.descripcion"
                                        cdkTextareaAutosize
                                        #autosize="cdkTextareaAutosize"
                                        cdkAutosizeMinRows="1"
                                        cdkAutosizeMaxRows="5"></textarea>
                                </mat-form-field>
                                <!--
                                <mat-form-field *ngIf="action != 'Delete'" fxFlex>
                                  <input placeholder="Descripcion" matInput [(ngModel)]="new_line_p.descripcion">
                                </mat-form-field>-->
                              </div>
                            </div>
                            <div fxFlex="20">
                              <button mat-button (click)="addLine()" mat-flat-button color="primary" class="add-row">Grabar</button>
                            </div>
                          </div>
                          <div fxFlex *ngIf="action != 'Delete'">
                            <table mat-table [dataSource]="dataSource" #tableProbabilidad class="my-table mat-elevation-z8 select-list" >

                              <!--- Note that these columns can be defined in any order.
                                  The actual rendered columns are set as a property on the row definition" -->

                              <!-- User Column -->

                              <ng-container matColumnDef="nombre">
                                <th mat-header-cell *matHeaderCellDef> Nombre </th>
                                <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                              </ng-container>

                              <ng-container matColumnDef="descripcion">
                                <th mat-header-cell *matHeaderCellDef> Descripcion </th>
                                <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                              </ng-container>

                              <ng-container matColumnDef="valor">
                                <th mat-header-cell *matHeaderCellDef> Valor </th>
                                <td mat-cell *matCellDef="let element"> {{element.valor | number:'1.2-2'}} </td>
                              </ng-container>

                              <!-- Action Column -->
                              <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef> Acción </th>
                                <td mat-cell *matCellDef="let element" class="action-link">
                                  <a (click)="edit(element)" *ngIf="action != 'View' && action != 'Delete'">Editar</a>
                                  <span *ngIf="action != 'View' && action != 'Delete'">|</span>
                                  <a (click)="remove(element)" *ngIf="action != 'View' && action != 'Delete'">Eliminar</a>
                                </td>
                              </ng-container>

                              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                          </div>
                      </div>
                    </mat-card-content>

                  </mat-card>

                  <mat-card class="example-card">
                    <mat-card-header>
                      <mat-card-title>Impactos</mat-card-title>

                    </mat-card-header>

                    <mat-card-content>
                      <div class="content p-5" fxLayout="column" fxFlex>

                        <div fxLayout="row" fxFlex *ngIf="action != 'View' && action != 'Delete'">
                          <div fxLayout="column" fxFlex>
                            <div fxFlex>
                              <mat-form-field *ngIf="action != 'Delete'" fxFlex="80">
                                <input placeholder="Nombre" matInput [(ngModel)]="new_line_i.nombre">
                              </mat-form-field>
                              <mat-form-field *ngIf="action != 'Delete'" class="select-edit-number" fxFlex="20">
                                <input placeholder="Valor" matInput [(ngModel)]="new_line_i.valor" type="number" value=""
                                onkeypress="return event.charCode >= 48 || event.charCode == 46"
                                pattern="[0-9]+([\.][0-9]+)?"  min="0.01" step="0.01">
                              </mat-form-field>
                            </div>
                            <div fxFlex>
                              <mat-form-field fxFlex>
                                <mat-label>Descripción</mat-label>
                                <textarea
                                      matInput [(ngModel)]="new_line_i.descripcion"
                                      cdkTextareaAutosize
                                      #autosize="cdkTextareaAutosize"
                                      cdkAutosizeMinRows="1"
                                      cdkAutosizeMaxRows="5"></textarea>
                              </mat-form-field>

                            </div>
                          </div>
                          <div fxFlex="20">
                            <button mat-button (click)="addLineI()" mat-flat-button color="primary" class="add-row">Grabar</button>
                          </div>
                        </div>

                        <div fxFlex *ngIf="action != 'Delete'">
                          <table mat-table [dataSource]="dataSourceI" #tableImpacto class="my-table mat-elevation-z8 select-list" >

                            <!--- Note that these columns can be defined in any order.
                                The actual rendered columns are set as a property on the row definition" -->

                            <!-- User Column -->

                            <ng-container matColumnDef="nombre">
                              <th mat-header-cell *matHeaderCellDef> Nombre </th>
                              <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
                            </ng-container>

                            <ng-container matColumnDef="descripcion">
                              <th mat-header-cell *matHeaderCellDef> Descripcion </th>
                              <td mat-cell *matCellDef="let element"> {{element.descripcion}} </td>
                            </ng-container>

                            <ng-container matColumnDef="valor">
                              <th mat-header-cell *matHeaderCellDef> Valor </th>
                              <td mat-cell *matCellDef="let element"> {{element.valor | number:'1.2-2'}} </td>
                            </ng-container>

                            <!-- Action Column -->
                            <ng-container matColumnDef="action">
                              <th mat-header-cell *matHeaderCellDef> Acción </th>
                              <td mat-cell *matCellDef="let element" class="action-link">
                                <a (click)="editI(element)" *ngIf="action != 'View' && action != 'Delete'">Editar</a>
                                <span *ngIf="action != 'View' && action != 'Delete'">|</span>
                                <a (click)="removeI(element)" *ngIf="action != 'View' && action != 'Delete'">Eliminar</a>
                              </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                          </table>
                        </div>

                      </div>
                    </mat-card-content>

                  </mat-card>


                  <!-- / CONTENT -->
                </mat-tab>
                <mat-tab label="Fórmula de exposición - Apetito y Tolerancia" >

                  <div class="p-20" >
                    <mat-form-field *ngIf="action != 'Delete'" class="select-edit px-10">
                      <input placeholder="Formula de exposición ej: (P*0.4)+(I*0.6)" matInput [(ngModel)]="LOCAL_DATA.formulaDeExposicion" (ngModelChange)="formulaModificada()"
                      onkeypress="return (event.charCode >= 40 && event.charCode <= 57 && event.charCode != 44) || event.charCode == 73 || event.charCode == 80 "
                      [disabled]="action == 'View'">
                    </mat-form-field>
                    <mat-form-field *ngIf="action != 'Delete'" class="select-edit-number px-10">
                      <input placeholder="Apetito" matInput [(ngModel)]="LOCAL_DATA.apetito" type="number" value="" step="any" [disabled] ="action == 'View'">
                    </mat-form-field>
                    <mat-form-field *ngIf="action != 'Delete'" class="select-edit-number px-10">
                      <input placeholder="Tolerancia" matInput [(ngModel)]="LOCAL_DATA.tolerancia" type="number" value="" step="any" [disabled] ="action == 'View'">
                    </mat-form-field>
                    <button mat-button (click)="calcularResultados()" mat-flat-button color="primary" class="add-row"
                      *ngIf="action != 'View' && action != 'Delete'">Calcular</button>
                  </div>

                  <mat-card class="example-card">
                    <mat-card-header>
                      <mat-card-title>Exposiciones</mat-card-title>

                    </mat-card-header>

                    <mat-card-content>
                      <div class="content p-5">
                          <table mat-table [dataSource]="dataSourceR"  #tableResultados class="my-table mat-elevation-z8 select-list" >

                            <ng-container matColumnDef="probabilidad">
                              <th mat-header-cell *matHeaderCellDef> Probabilidad</th>
                              <td mat-cell *matCellDef="let element"> {{element.probabilidad.nombre}}({{element.probabilidad.valor | number:'1.2-2'}}) </td>
                            </ng-container>

                            <ng-container matColumnDef="impacto">
                              <th mat-header-cell *matHeaderCellDef>  Impacto</th>
                              <td mat-cell *matCellDef="let element"> {{element.impacto.nombre}}({{element.impacto.valor | number:'1.2-2'}}) </td>
                            </ng-container>

                            <ng-container matColumnDef="resultado">
                              <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
                              <td mat-cell *matCellDef="let element"> {{element.resultado | number:'1.2-2'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="action">
                              <th mat-header-cell *matHeaderCellDef> </th>
                              <td mat-cell *matCellDef="let element" class="action-link">
                                <button mat-button mat-raised-button (click)="setApetito(element)" class="px-20" style="margin-right:20px"
                                *ngIf="action != 'View' && action != 'Delete'">A</button>
                                <button mat-button mat-raised-button (click)="setTolerancia(element)"  class="px-20"
                                *ngIf="action != 'View' && action != 'Delete'">T</button>
                              </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsResults"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsResults;"></tr>
                          </table>


                      </div>
                    </mat-card-content>

                  </mat-card>

                  <mat-card class="example-card">
                    <mat-card-header>
                      <mat-card-title></mat-card-title>

                    </mat-card-header>

                    <mat-card-content>
                      <div class="chart-data p-40">
                        <ngx-charts-heat-map
                            [view]="view"
                            [scheme]="colorScheme"
                            [legend]="legend"
                            [gradient] = "gradient"
                            [showXAxisLabel]="showXAxisLabel"
                            [showYAxisLabel]="showYAxisLabel"
                            [xAxis]="xAxis"
                            [yAxis]="yAxis"
                            [xAxisLabel]="xAxisLabel"
                            [yAxisLabel]="yAxisLabel"
                            [results]="multi"
                            [customColors]="customColors"
                            (select)="onSelect($event)"
                            (activate)="onActivate($event)"
                            (deactivate)="onDeactivate($event)"
                            >
                          </ngx-charts-heat-map>
                      </div>

                    </mat-card-content>

                  </mat-card>

                </mat-tab>
            </mat-tab-group>

          </div>
          <!-- / CONTENT CARD -->



</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()" *ngIf="action != 'View'">{{action | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
